/**
 * package: com.inq.flash.client.data
 * class: ChatVideoPlayerStatusMessage
 * @constructor
 */
com.inq.flash.client.data.ChatVideoPlayerStatusMessage = function (chat, text) {
	com.inq.flash.client.data.ChatCommunicationMessage.call(this, chat, text);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_VIDEOPLAYER_STATUS);
};

$hxClasses.extend(com.inq.flash.client.data.ChatCommunicationMessage,
	com.inq.flash.client.data.ChatVideoPlayerStatusMessage,
	"com.inq.flash.client.data.ChatVideoPlayerStatusMessage"
);